import { NodeKind, type CompositionNode } from '@/core/document'
import type { ExportOptions } from '@/core/export'
import type { EditSessionState } from '@/core/store/editSession'
import type { ReportingDocumentShape } from '@/core/reporting/types'

function countNodes(node: CompositionNode): number {
  switch (node.kind) {
    case NodeKind.Image:
      return 1
    case NodeKind.Frame:
      return 1 + countNodes(node.child)
    case NodeKind.Collage:
      return 1 + [...node.cells, ...node.tray].reduce(
        (total, child) => total + (child ? countNodes(child) : 0),
        0,
      )
  }
}

export function createReportingDocumentShape(
  state: Pick<EditSessionState, 'document' | 'exportOptions'>,
): ReportingDocumentShape | undefined {
  const { document } = state
  if (!document) return undefined
  const options: ExportOptions = state.exportOptions
  return {
    rootKind: document.root.kind,
    nodeCount: countNodes(document.root),
    presetId: document.output.presetId,
    splitKind: document.output.split?.kind ?? null,
    format: options.format,
    resizeMode: options.resizeMode,
    jpegQuality: options.jpegQuality,
  }
}
